import { UrlObject } from 'node:url';
import NextLink from 'next/link';
import Router from 'next/router';
import React from 'react';
import styled from 'styled-components';

export const Link = styled(
  ({
    href,
    path,
    children,
    ...props
  }: {
    className?: string;
    href: string | UrlObject;
    path?: string;
  } & React.HTMLAttributes<HTMLAnchorElement>) => {
    if (typeof href === 'string' && !href.startsWith('/')) {
      return (
        <a href={href} {...props}>
          {children}
        </a>
      );
    }

    return (
      <NextLink href={href} as={path} {...props}>
        {children}
      </NextLink>
    );
  }
)<{ underline?: boolean }>`
  color: inherit;

  :hover {
    color: inherit;
  }

  text-decoration: ${({ underline }) => (underline ? 'underline' : 'none')};
`;

export async function routeTo(
  href: string | UrlObject,
  path?: string,
  scroll = true
) {
  await Router.push(href, path);
  if (scroll) {
    scrollToTop();
  }
}

function scrollToTop() {
  if (global.window) {
    global.window.scrollTo(0, 0);
  }
}
